import { InvoiceHistoryLog } from "@/modules/facturae/domain/InvoiceHistoryLog";

export class VueInvoiceHistoryLogListScreenData {
    invoiceHistoryLogs: InvoiceHistoryLog[];
    headers: Object;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    totalItems: number;
    tableHeight: string;
    limit: number;
    offset: number;

    constructor(){
        this.invoiceHistoryLogs = []
        this.headers = [
            {
                text: "Tipo",
                value: "invoice_type",
                sortable: false,
            },
            {
                text: "Id",
                value: "id",
                sortable: false,
            },
            {
                text: "CIF del emisor",
                value: "issuer_nif",
                sortable: false,
            },
            {
                text: "Número de factura",
                value: "invoice_series_number",
                sortable: false,
            },
            {
                text: "Fecha de emisión",
                value: "invoice_issue_date",
                sortable: false,
            },
            {
                text: "CIF del cliente",
                value: "third_party_nif",
                sortable: false,
            },
            {
                text: "Nombre del cliente",
                value: "third_party_name",
                sortable: false,
            },
            {
                text: "Total base imponible",
                value: "total_base_amount",
                sortable: false,
            },
            {
                text: "Total impuestos",
                value: "total_tax_amount",
                sortable: false,
            },
            {
                text: "Importe total",
                value: "total_amount",
                sortable: false,
            },
            {
                text: "Info verifactu",
                value: "info_verifactu",
                sortable: false,
            },
            {
                text: "Info Error",
                value: "error_to_show",
                sortable: false,
            },
            {
                text: "Fecha de registro",
                value: "register_generation_dt",
                sortable: false,
            },
            {
                text: "Número de registro",
                value: "agreement_register_number",
                sortable: false,
            },
            {
                text: "Número de factura externo",
                value: "external_invoice_number",
                sortable: false,
            },
            {
                text: "Cadena de bloques",
                value: "chain_hash",
                sortable: false,
            },
        ],
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.totalItems = 0;
        this.tableHeight = '59vh';
        this.limit = 10;
        this.offset = 0;
        this.calculateTableHeight();
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setTotalItems(totalItems: number){
        this.totalItems = totalItems
    }

    changeLimit(value) {
        this.limit = value;
        this.calculateTableHeight();
    }

    changeOffset(offset: number) {
        this.offset = offset;
        this.calculateTableHeight();
    }

    calculateTableHeight() {
        let initNumItemsPerPage = Math.min(this.limit, 10);
        if (this.totalItems == 0) {
            this.tableHeight = '20vh';
        }
        else {
            let tempTableHeight = 48 * (Math.min(this.totalItems, initNumItemsPerPage) + 1);
            this.tableHeight = (tempTableHeight).toString() + 'px'
        }
    }
}